import { createSlice } from "@reduxjs/toolkit";



export const defaultMaterial = {
  chemicalName: "",
  chemicalCode: "",
  density: '',
  basePrice: '',
  tax: '',
  chemicalType: "",
  companyName: "",
  addressLine1: "",
  contactInformation1: {
    name: "",
    contactNumber: "",
  },
  contactInformation2: {
    name: "",
    contactNumber: "",
  },
  contactInformation3: {
    name: "",
    contactNumber: "",
  },
};

const materialSlice = createSlice({
    name:'material',
    initialState: {
        list: [],
        selected: defaultMaterial,
        refreshNeeded: false,
    },
    reducers:{
        addMaterial:(state,action)=>{
            state.list =  action.payload;
        },
        addSingleMaterial:(state,action)=>{
            state.selected = { ...defaultMaterial, ...action.payload }; // ✅ merge to avoid missing fields

        },
        triggerRefresh: (state) => {
      state.refreshNeeded = true;
    },
    clearRefresh: (state) => {
      state.refreshNeeded = false;
    },
        fetchMaterial:(state,action)=>action.payload

    }

})

export const {addMaterial,addSingleMaterial,fetchMaterial,triggerRefresh,clearRefresh}  = materialSlice.actions;

export default materialSlice.reducer